import React, { createContext, useReducer } from "react";
import FeatureFlagReducer, { initialState } from "@reducers/FeatureFlagReducer";

export const FeatureFlagContext = createContext(undefined);

const FeatureFlagProvider = ({ children }) => {
  const [state, dispatch] = useReducer(FeatureFlagReducer, initialState);
  return (
    <FeatureFlagContext.Provider value={[state, dispatch]}>
      {children}
    </FeatureFlagContext.Provider>
  );
};

export default FeatureFlagProvider;
